import * as React from "react";
import type { SVGProps } from "react";
const SvgAlarmPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M1.4 7.008a1 1 0 1 0 2 0h-2M7.008 3.4a1 1 0 1 0 0-2v2m9.984-2a1 1 0 1 0 0 2v-2m.768 1v-1zm3.84 3.84h-1zm-1 .768a1 1 0 1 0 2 0h-2M6.563 19.619a1 1 0 1 0-1.414-1.414l.707.707zm-4.102 1.274a1 1 0 1 0 1.414 1.414l-.707-.707zm17.664 1.414a1 1 0 0 0 1.414-1.414l-.707.707zm-1.274-4.102a1 1 0 0 0-1.414 1.414l.707-.707zM13 9.6a1 1 0 1 0-2 0h2m-2 6a1 1 0 1 0 2 0h-2m4-2a1 1 0 1 0 0-2v2m-6-2a1 1 0 1 0 0 2v-2M2.4 7.008h1V6.24h-2v.768zM6.24 2.4v1h.768v-2H6.24zM2.4 6.24h1A2.84 2.84 0 0 1 6.24 3.4v-2A4.84 4.84 0 0 0 1.4 6.24zM16.992 2.4v1h.768v-2h-.768zM21.6 6.24h-1v.768h2V6.24zM17.76 2.4v1a2.84 2.84 0 0 1 2.84 2.84h2a4.84 4.84 0 0 0-4.84-4.84zM5.856 18.912l-.707-.707-2.688 2.688.707.707.707.707 2.688-2.688zM20.832 21.6l.707-.707-2.688-2.688-.707.707-.707.707 2.688 2.688zm-.384-8.832h-1A7.45 7.45 0 0 1 12 20.216v2a9.45 9.45 0 0 0 9.448-9.448zM12 21.216v-1a7.45 7.45 0 0 1-7.448-7.448h-2A9.45 9.45 0 0 0 12 22.216zm-8.448-8.448h1A7.45 7.45 0 0 1 12 5.32v-2a9.45 9.45 0 0 0-9.448 9.448zM12 4.32v1a7.45 7.45 0 0 1 7.448 7.448h2A9.45 9.45 0 0 0 12 3.32zm0 5.28h-1v3h2v-3zm0 3h-1v3h2v-3zm3 0v-1h-3v2h3zm-3 0v-1H9v2h3z"
    />
  </svg>
);
export default SvgAlarmPlus;
